export const TASK_CONFIG = {
  'roleRecertification.userRoleRecertification': {
    configPath: 'program.0.taskDefinition.userRoleRecertificationBulk',
    partitionType: 'userEntityType',
  },
  'roleRecertification.userRoleRecertification.teamManagementExpansion': {
    configPath: 'program.0.taskDefinition.userRoleRecertificationBulkTME',
    partitionType: 'roleCategory',
  },
};

export const PARTITION_TYPES = {
  userEntityType: {
    processVariableId: 'entityTypeId',
    selectionName: 'entityTypeName',
    label: 'user category type',
  },
  roleCategory: {
    processVariableId: 'entityTypeId',
    selectionName: 'entityTypeName',
    label: 'role category',
  },
  fo: {
    processVariableId: 'fundingOpportunityId',
    selectionName: 'fundingOpportunityName',
    label: 'funding opportunity',
  },
  program: {
    processVariableId: 'programId',
    processVariableName: 'programName',
    label: 'program',
  },
};
